import { Chip } from '@aibees/shared/components';
import { LOOM_WHAT_FULL_DEMO } from '@aibees/shared/constants';
import { classnames } from '@aibees/shared/utils';
import { Box, Modal, Typography } from '@mui/material';
import { memo, useState } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { VideoCardProps as Props } from './types';

export const VideoCard = memo(({ className }: Props) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Styled.Wrapper className={classnames('VideoCard', className)} sx={SX.root}>
      <Typography variant="body3" fontWeight={700}>
        What Makes US Different?
      </Typography>
      <Typography variant="body4" fontWeight={400}>
        Discover how we outperform Apollo, ZoomInfo, and Ocean.io powered by AI.
      </Typography>

      <Box sx={SX.videoBox}>
        <Styled.Img
          src="/assets/images/video-image.jpg"
          alt="Video Thumbnail"
        />

        <Styled.Avatar
          alt="Person Avatar"
          src="/assets/images/video-avatar.png"
        />
      </Box>

      <Chip
        label="Watch Full Demo"
        onClick={handleClickOpen}
        variant="filled"
        color="primary"
        size="small"
        sx={SX.chip}
      />

      <Modal open={open} onClose={handleClose}>
        <Box sx={SX.modalBox}>
          <Box
            component="iframe"
            src={LOOM_WHAT_FULL_DEMO}
            title="Credit Usage Guide"
            allowFullScreen
            sx={SX.modalIframe}
          />
        </Box>
      </Modal>
    </Styled.Wrapper>
  );
});

VideoCard.displayName = 'VideoCard';
